<nz-modal [(nzVisible)]="visible" 
          nzTitle="Configurar Fonte de Dados" 
          [nzWidth]="'900px'"
          (nzOnOk)="handleOk()" 
          (nzOnCancel)="handleCancel()"
          [nzOkText]="'Salvar'"
          [nzCancelText]="'Cancelar'">
  
  <div *nzModalContent style="padding: 16px;">
    <!-- Seletor de Tipo -->
    <nz-form-item>
      <nz-form-label nzRequired>Tipo de Fonte de Dados</nz-form-label>
      <nz-form-control>
        <nz-radio-group [(ngModel)]="selectedType">
          <label nz-radio nzValue="none">Nenhum</label>
          <label nz-radio nzValue="formula">Fórmula</label>
          <label nz-radio nzValue="mock">Mock JSON</label>
          <label nz-radio nzValue="api">API</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <nz-divider></nz-divider>

    <!-- NENHUM -->
    <div *ngIf="selectedType === 'none'">
      <nz-alert 
        nzType="info" 
        nzMessage="Nenhuma fonte de dados configurada"
        nzDescription="O launcher não terá dados pré-carregados automaticamente."
        nzShowIcon>
      </nz-alert>
    </div>

    <!-- FÓRMULA: Abre FormulaTesterComponent existente -->
    <div *ngIf="selectedType === 'formula'">
      <nz-form-item>
        <nz-form-label>Descrição</nz-form-label>
        <nz-form-control>
          <input nz-input 
                 [(ngModel)]="formulaConfig.description" 
                 placeholder="Descreva o que esta fórmula retorna (ex: Lista de pedidos do cliente)"/>
        </nz-form-control>
      </nz-form-item>

      <nz-alert nzType="info" 
                nzMessage="Clique no botão abaixo para abrir o editor de fórmulas"
                nzShowIcon
                style="margin-bottom: 16px;">
      </nz-alert>

      <button nz-button nzType="primary" (click)="openFormulaEditor()">
        <i nz-icon nzType="edit"></i> Configurar Fórmula
      </button>

      <div *ngIf="formulaConfig.expression" style="margin-top: 16px;">
        <nz-tag nzColor="success">
          <i nz-icon nzType="check-circle"></i> Fórmula configurada
        </nz-tag>
        <div style="margin-top: 8px;">
          <nz-descriptions nzBordered nzSize="small">
            <nz-descriptions-item nzTitle="Expressão" [nzSpan]="3">
              <pre style="margin: 0; background: #f5f5f5; padding: 8px; border-radius: 4px; max-height: 200px; overflow: auto;">{{ formulaConfig.expression }}</pre>
            </nz-descriptions-item>
            <nz-descriptions-item nzTitle="Variáveis" [nzSpan]="3" *ngIf="formulaConfig.variables && formulaConfig.variables.length > 0">
              <nz-tag *ngFor="let variable of formulaConfig.variables" nzColor="blue">
                {{ variable.key }}: {{ variable.value }}
              </nz-tag>
            </nz-descriptions-item>
          </nz-descriptions>
        </div>
      </div>
    </div>

    <!-- MOCK JSON: Editor inline -->
    <div *ngIf="selectedType === 'mock'">
      <nz-form-item>
        <nz-form-label>Descrição</nz-form-label>
        <nz-form-control>
          <input nz-input 
                 [(ngModel)]="mockConfig.description" 
                 placeholder="Descreva estes dados mock (ex: Dados de teste para desenvolvimento)"/>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>JSON de Dados</nz-form-label>
        <nz-form-control>
          <textarea nz-input 
                    [(ngModel)]="mockConfig.jsonData" 
                    rows="15"
                    placeholder='{"items": [{"id": 1, "name": "Item 1"}]}'
                    style="font-family: 'Courier New', monospace; font-size: 13px;"></textarea>
        </nz-form-control>
      </nz-form-item>

      <button nz-button nzType="dashed" (click)="validateMockJson()">
        <i nz-icon nzType="check-circle"></i> Validar JSON
      </button>
    </div>

    <!-- API: Configuração inline -->
    <div *ngIf="selectedType === 'api'">
      <nz-form-item>
        <nz-form-label>Descrição</nz-form-label>
        <nz-form-control>
          <input nz-input 
                 [(ngModel)]="apiConfig.description" 
                 placeholder="Descreva esta API (ex: API de produtos Shopee)"/>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>URL</nz-form-label>
        <nz-form-control>
          <input nz-input 
                 [(ngModel)]="apiConfig.url" 
                 placeholder="https://api.example.com/data"/>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Método HTTP</nz-form-label>
        <nz-form-control>
          <nz-select [(ngModel)]="apiConfig.method" style="width: 100%;">
            <nz-option nzValue="GET" nzLabel="GET"></nz-option>
            <nz-option nzValue="POST" nzLabel="POST"></nz-option>
            <nz-option nzValue="PUT" nzLabel="PUT"></nz-option>
            <nz-option nzValue="DELETE" nzLabel="DELETE"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-divider nzText="Headers"></nz-divider>
      
      <div *ngFor="let headerKey of getHeaderKeys()" style="margin-bottom: 8px;">
        <nz-space>
          <input *nzSpaceItem 
                 nz-input 
                 [value]="headerKey"
                 (change)="updateHeaderKey(headerKey, $event.target.value)"
                 placeholder="Header Key" 
                 style="width: 200px;"/>
          <input *nzSpaceItem 
                 nz-input 
                 [(ngModel)]="apiConfig.headers[headerKey]"
                 placeholder="Header Value" 
                 style="width: 300px;"/>
          <button *nzSpaceItem 
                  nz-button 
                  nzType="link" 
                  nzDanger 
                  (click)="removeHeader(headerKey)">
            <i nz-icon nzType="delete"></i>
          </button>
        </nz-space>
      </div>

      <button nz-button nzType="dashed" (click)="addHeader()" style="margin-top: 8px;">
        <i nz-icon nzType="plus"></i> Adicionar Header
      </button>

      <nz-form-item *ngIf="apiConfig.method === 'POST' || apiConfig.method === 'PUT'" style="margin-top: 16px;">
        <nz-form-label>Body (JSON)</nz-form-label>
        <nz-form-control>
          <textarea nz-input 
                    [(ngModel)]="apiConfig.body" 
                    rows="8"
                    placeholder='{"key": "value"}'
                    style="font-family: 'Courier New', monospace; font-size: 13px;"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Botão de Teste -->
    <div *ngIf="selectedType !== 'none'" style="margin-top: 24px;">
      <button nz-button 
              nzType="dashed" 
              (click)="testCurrentConfig()"
              [nzLoading]="testing">
        <i nz-icon nzType="experiment"></i> Testar Configuração
      </button>
    </div>

    <!-- Resultado do Teste -->
    <div *ngIf="testResult" style="margin-top: 16px;">
      <nz-alert 
        [nzType]="testResult.success ? 'success' : 'error'" 
        [nzMessage]="testResult.message"
        nzShowIcon
        nzCloseable
        (nzOnClose)="testResult = null">
        <div *nzAlertDescription style="max-height: 400px; overflow: auto;">
          <pre style="margin: 0; background: #f5f5f5; padding: 12px; border-radius: 4px; font-size: 12px;">{{ testResult.data }}</pre>
        </div>
      </nz-alert>
    </div>
  </div>
</nz-modal>

